import { render, staticRenderFns } from "./SidebarElement.vue?vue&type=template&id=6ec61f7e&scoped=true&"
import script from "./SidebarElement.vue?vue&type=script&lang=js&"
export * from "./SidebarElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec61f7e",
  null
  
)

export default component.exports